import request from "../utils/request";

export const getDictTypes = '/dict/types'

export function getAllDictTypes() {
    return request.get('/dict/types');
}

export function getAllDicts() {
    return request.get('/dict/all');
}

export function getDict(typeId: number) {
    return `/dict/?typeId=${typeId}`
}

export function modifyDict(values: any) {
    return request.request({
        url: '/dict/',
        method: values.id ? 'put' : 'post',
        data: values
    })
}

export function deleteDict(dictId: number) {
    return request.request({
        url: '/dict/',
        method: 'delete',
        params: {dictId}
    })
}

export function getCommonData() {
    return request.get('/dict/baseData')
}
